import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAuthPageBottomLocationIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 34,
	viewBox: "0 0 34 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M33.9198 16.7237C33.9198 25.9091 26.4735 33.3555 17.288 33.3555C8.10256 33.3555 0.65625 25.9091 0.65625 16.7237C0.65625 7.53817 8.10256 0.0918579 17.288 0.0918579C26.4735 0.0918579 33.9198 7.53817 33.9198 16.7237Z",
		fill: "#FFE1FF"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 5.10742,
		y: 17.1021,
		width: 17.498,
		height: 16.9625,
		transform: "rotate(-45 5.10742 17.1021)",
		fill: "#822BD9"
	})]
});
export default SvgAuthPageBottomLocationIcon;
